<template>
  <div class="main">
    <div class="stepper">
      <div class="line" :style="{ width: lengthLine + 'rem' }"></div>
      <ul>
        <li
          v-for="(answer, index) in answers"
          :key="index"
          :class="{ correct: isCorrect(answer), wrong: isWrong(answer) }"
        >
          <span v-if="unanswered(answer)">{{ index + 1 }}</span>
          <FontAwesomeIcon v-else :icon="getIcon(answer)" />
        </li>
      </ul>
    </div>

    <div class="hud">
      <transition name="slide-top-fade">
        <div class="animated-flourish-coins" v-if="showCoinsAnimation">
          <span>+5</span>
          <img
            src="@/assets/images/flourish-coin-darker.svg"
            width="32px"
            height="32px"
            alt=""
          />
        </div>
      </transition>

      <div v-if="showCoins" class="flourish-coins">
        <span>{{ coins }}</span>
        <img
          src="@/assets/images/flourish-coin.svg"
          width="35px"
          height="35px"
          alt=""
        />
      </div>
      <div>
        <slot name="countdown"> </slot>
      </div>

      <!--<transition name="slide-top-fade">
        <div class="animated-do-over" v-if="showDoOverAnimation">
          <span>-1</span>
          <img
            src="@/assets/images/life.svg"
            width="35px"
            height="35px"
            alt=""
          />
        </div>
      </transition>

      <div class="do-over">
        <span v-if="!showCoins && doOvers > 0" class="try-again"
          >Try again!</span
        >
        <img src="@/assets/images/life.svg" width="35px" height="35px" alt="" />
        <span class="doOvers">{{ doOversAvailable }}</span>
      </div>-->
    </div>
  </div>
</template>

<script>
import { questionsResult } from "../utils/enums";
import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";

export default {
  props: {
    amountOfQuestions: Number,
    totalCoins: Number,
    //doOvers: Number,
    showCountdown: Boolean,
    showCoins: Boolean,
    answers: { type: Array, required: true },
  },
  data: () => ({
    currentIndex: 0,
    showCoinsAnimation: false,
    //showDoOverAnimation: false,
  }),
  methods: {
    getIcon(answer) {
      return answer == questionsResult.CORRECT ? faCheck : faTimes;
    },
    unanswered(answer) {
      return answer == null;
    },
    isCorrect(answer) {
      return answer == questionsResult.CORRECT;
    },
    isWrong(answer) {
      return (
        answer == questionsResult.WRONG || answer == questionsResult.TIMEOUT
      );
    },
    startCoinsAnimation() {
      this.showCoinsAnimation = true;
      let interval = setTimeout(() => {
        this.showCoinsAnimation = false;
        clearTimeout(interval);
      }, 2000);
    },
    // startDoOverAnimation() {
    //   this.showDoOverAnimation = true;
    //   let interval = setTimeout(() => {
    //     this.showDoOverAnimation = false;
    //     clearTimeout(interval);
    //   }, 2000);
    // },
  },
  computed: {
    lengthLine() {
      return this.answers.length * 2.5;
    },
    coins() {
      if (this.totalCoins > 0) {
        this.startCoinsAnimation();
      }
      return this.totalCoins;
    },
    // doOversAvailable() {
    //   if (this.doOvers == 0) {
    //     this.startDoOverAnimation();
    //   }
    //   return this.doOvers;
    // },
  },
};
</script>

<style lang="scss" scoped>
@import "../scss/variables.scss";

.main {
  position: relative;
  margin: 1rem auto;
  width: 100%;
}

.stepper {
  display: flex;
  margin: 2rem auto 1rem auto;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

ul {
  padding: 0;
  margin: 0 auto;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}

li {
  width: 2rem;
  height: 2rem;
  position: relative;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin: 0 0.6rem;
  background-color: $quinternary;
  border-radius: 50%;
  text-align: center;
  font-size: 1.1rem;
  color: $secondary-darker;
  font-family: $secondary-font;
}

.line {
  position: relative;
  top: 1.2rem;
  height: 1px;
  border-top: 3px solid $secondary;
}

.wrong {
  background-color: $tertiary;
  color: $quaternary;
}

.correct {
  background-color: $secondary;
  color: $quaternary;
}

.hud {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.flourish-coins {
  display: flex;
  align-items: center;
  justify-content: center;
  align-items: center;
}

.flourish-coins > span {
  font-family: $primary-font;
  background-color: $secondary;
  border-radius: 12px;
  font-size: 1.4rem;
  color: white;
  padding: 0.05rem 2rem 0.05rem 0.6rem;
}

.flourish-coins > img {
  transform: translateX(-60%);
}

.do-over {
  display: flex;
  align-items: center;
  justify-content: center;
  align-items: center;
}

.do-over > span {
  font-family: $primary-font;
}

.do-over > img {
  position: relative;
  transform: translateX(60%);
}

.try-again {
  color: $tertiary;
}

// .doOvers {
//   background-color: $tertiary;
//   border-radius: 12px;
//   font-size: 1.4rem;
//   color: white;
//   padding: 0.05rem 2rem 0.05rem 0.6rem;
//   padding: 0.01rem 0.6rem 0.01rem 2rem;
// }

.animated-flourish-coins {
  position: absolute;
  display: flex;
  align-items: center;
  top: 5.5rem;
}

.animated-flourish-coins > span {
  font-family: $secondary-font;
  color: $secondary-darker;
}

.animated-do-over {
  position: absolute;
  display: flex;
  align-items: center;
  top: 5.5rem;
  left: 18rem;
}

.animated-do-over > span {
  font-family: $primary-font;
  color: $tertiary;
}
</style>
